module.exports = __webpack_public_path__ + "media/images/trash-7860dcdf6d6780c65e8862eb5bdc25b3.svg";